import { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import RouterContent from './RouterContent';
import { AppSettingsGetter } from '../context/AppSettingsContext';
import { useAppSettingsStateStore } from '../context/AppSettingsStateContext';
import { ApiEndpointsGetter } from '../context/ApiEndpointsContext';

const AppRouter = () => {
    const { isGettingAppSettings, isGettingApiEndpoints, setGettingAppSettings, setIsGettingApiEndpoints } = useAppSettingsStateStore();

    useEffect(() => {
        const fetchData = async () => {
            setGettingAppSettings(true);
            setIsGettingApiEndpoints(true);

            const appSettings = await new AppSettingsGetter().getAppSettings();
            setGettingAppSettings(false);

            await new ApiEndpointsGetter().getApiEndpoints(appSettings);
            setIsGettingApiEndpoints(false);
        };

        fetchData();
    }, []);

    return <Router>{!isGettingAppSettings && !isGettingApiEndpoints && <RouterContent />}</Router>;
};

export default AppRouter;
